"use client";

import { useTranslations } from "next-intl";
import {
    GameCreationImage1,
    GameCreationImage2,
    GameCreationImage3,
    GameCreationImage4,
    GameCreationImage5,
    GameCreationImage6,
} from "../../assets";
import UserGuideImage from "./UserGuideImage";

export default function GameCreationGuide() {
    const t = useTranslations("gameCreation");

    return (
        <article className="mx-auto max-w-4xl px-6 py-8 text-[15px] leading-relaxed text-neutral-800 sm:px-10 sm:py-10 sm:text-base">
            <h1 className="mb-8 text-center text-xl font-bold sm:text-2xl">
                {t("headerTitle")}
            </h1>

            <div className="mb-8">
                <UserGuideImage image={GameCreationImage1} />
            </div>

            <p className="mb-6 indent-8 text-justify">
                {t("title")}
            </p>

            <h2 className="mb-4 indent-4 text-base font-bold sm:text-lg">
                {t("stepTitle")}
            </h2>

            <p className="mb-4 indent-4 text-justify">
                {t("step1")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step2")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={GameCreationImage2} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step3")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step4")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step5")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step6")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={GameCreationImage3} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step7")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={GameCreationImage4} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step8")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step9")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step10")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step11")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step12")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step13")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step14")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={GameCreationImage5} />
            </div>

            <p className="mb-6 indent-4 text-justify">
                {t("step15")}
            </p>

            <div className="mb-4">
                <UserGuideImage image={GameCreationImage6} />
            </div>
        </article>
    );
}
